//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-router/lib-esm/interface.js
// module id = 377
// module chunks = 1